// components/FlexBox.tsx
import Box, { BoxProps } from "@mui/material/Box";

// Define a new component that defaults to display="flex"
const FlexBox: React.FC<BoxProps> = (props) => {
  return <Box {...props} display="flex" />;
};

export default FlexBox;
